import { $fetch } from 'vfetcher/ofetch'
import router from "@/router";
import { getUser } from "@/store/auth/state.js";
import { useToast } from "primevue/usetoast";

export default {
  install: (app, options) => {
    app.config.globalProperties.$apiSezUs = $fetch.create({
      baseURL: '/api',
      headers:{        
        "X-Sez-Platform": "web",
      },
      onRequest({ request, options }) {
        // Only log API requests in development mode
        if (import.meta.env.MODE === 'development') {
          console.log("Intercepted API", request);
        }
      },
      async onResponseError({ response }) {
        if (response.status === 401) {
          router.push('/');
        }
        else if (response.status === 403) {
          router.push('/');
        }
      }
    })
  }
}
